import React, {useEffect, useState} from "react";
import zoomImg from "../../../../assets/icons/imgBtn.svg";
import BlogImagePopper from "./BlogImageLarge";
import image1 from "../../../../assets/images/Blog31/image1 nas100 new ATH close.png";
import image3 from "../../../../assets/images/Blog31/image3 MAG7 and FANGS drag NAS100 to high.png";
import image4 from "../../../../assets/images/Blog31/imagenumber4.png";
import image2 from "../../../../assets/images/Blog31/image2 SPX one more high_ (1).png";
import image5 from "../../../../assets/images/Blog31/image5 US10Y has ticked lower in triangle.png";
import image7 from "../../../../assets/images/Blog31/image7 OIL breakdown on Ukraine peace chances.png";
import image16 from "../../../../assets/images/Blog31/image16 GU back to slow and cautious cuts consensus.png";
import image8 from "../../../../assets/images/Blog31/image8 Gold has options.png";
import image14 from "../../../../assets/images/Blog31/image14 Gold nears wave a spot top.png";
import image15 from "../../../../assets/images/Blog31/image15 GC gold grind near wave a top.png";
import image6 from "../../../../assets/images/Blog31/image6 DXY clinging to 50dma.png";
import image17 from "../../../../assets/images/Blog31/image17 US claims data.png";

const Blog31 = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleRedirect = (url) => {
    window.open(url, "_blank");
  };
  const handleLargeImg = (img) => {
    setSelectedImage(img);
  };
  return (
    <div className="MainNewBlog">
      <div className="blogHeader">
        <h2 className="headerBoldText mainHeader">Weekly Market Outlook – August 11th, 2025</h2>
      </div>
      <div className="blogContentnew">
        <p className="highlightedText">Peace Whispers, Tariff Tsunamis, and Gold’s Tug-of-War</p>
        <p>
          Markets stormed into the second week of August with their strongest performance since June, powered by tech mega-caps, peace chatter between Washington and Moscow, and selective tariff
          exemptions. Beneath the euphoria, breadth remains thin, macro risks are mounting, and summer liquidity could amplify volatility in both directions.
        </p>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Market Overview – A Rally Running on Thin Ice</p>
              <p>
                The <span className="highlightedText">Nasdaq 100 </span> and the <span className="highlightedText">Magnificent Seven</span> locked in fresh all-time highs, with
                <span className="highlightedText"> Apple</span> delivering its best week since 2020 — up 13.33% — after announcing a $100B US manufacturing plan to sidestep chip tariffs.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image1}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image1)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image3}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image3)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image4}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image4)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                The <span className="highlightedText">S&P 500</span> approached 6,400, but momentum continues to diverge, with medium-term breadth flat near 50%. The{" "}
                <span className="highlightedText">US 10-year yield </span>rose seven basis points to 4.28%, the dollar clung to its 50dma, oil slid on potential Russian supply returns, and gold
                fluctuated within a volatile range.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image2}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image2)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image5}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image5)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image7}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image7)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper flexDiv ">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Macro & Policy Watch – Tariffs and Peace in the Same Breath</p>

              <p>
                The US is reportedly working with Russia toward a territorial deal in Ukraine, with a<span className="highlightedText"> Trump–Putin summit </span> possible as early as next week. At
                the same time, Trump unleashed aggressive tariffs — 100% on semiconductors, 250% on pharmaceuticals, plus an extra 25% on India for Russian oil imports — while dangling exemptions for
                US-based producers.
              </p>

              <p>
                Treasury Secretary Bessent projected tariff revenues could exceed $300B annually. The <span className="highlightedText">RBA </span>is widely expected to cut rates by 25bps this week,
                while China’s CPI slipped back to 0%, raising the threat of exported deflation into the West — a setup that could support bonds in the short term.
              </p>

              <p>From BoA’s Michael Hartnett:</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>Best YTD performers: Russian ruble (+42%), Polish equities (+54%), Ukrainian bonds (+61%).</p>
                </li>
                <li className="themesPointer">
                  <p>Peace winners: Japan, China, India (oil importers set for tariff relief).</p>
                </li>
                <li className="themesPointer">
                  <p>Peace losers: Defence, tech, and Middle East markets.</p>
                </li>
                <li className="themesPointer">
                  <p>Dollar remains in a structural bear market; China stands as the standout “peak tariff” play.</p>
                </li>
              </ul>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image16}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image16)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Technical & Sentiment Breakdown – Melt-Up or Blow-Off?</p>
              <p>
                Index price action is being driven by narrowing leadership and sentiment chasing. With 90% of S&P earnings reported, the market is leaning heavily toward a
                <span className="highlightedText"> Q3/Q4 seasonal rally peak,</span> but the technicals warn of exhaustion.
              </p>
              <p>
                <span className="highlightedText"> Gold </span>remains in a complex wave 5 structure, with buy support at 3240–3260 (GC 3300–3320) and resistance at 3400–3430 (GC 3480–3530). A
                pullback could set up a sharp upside breakout into late Q3/Q4 — potentially in sync with a final equity high.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image8}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image8)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image14}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image14)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image15}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image15)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv ">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Last Week’s Recap – Tech Fireworks, Tariff Ripples, and Gold’s Standoff</p>
              <p>
                <span className="highlightedText"> Equities </span>– Apple’s monster rally on tariff exemption hopes dominated headlines.
                <span className="highlightedText"> Fannie Mae & Freddie Mac</span> soared on IPO speculation valued at up to $500B. Shopify (+22%) crushed earnings estimates, while Pfizer (+5%) raised
                guidance. AMD slid on an EPS miss despite revenue growth, and gold stalled at resistance as expected in the wave structure.
              </p>
              <p>
                <span className="highlightedText">Macro</span> – Tariff news swung sentiment intraday, with exemptions boosting certain sectors while pharma and semiconductor names felt the pinch.
                China’s CPI flatlined, reinforcing deflation risks. The dollar softened for a fifth straight day, and oil’s breakdown reflected the peace premium unwinding.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image6}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image6)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image7}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image7)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>

              <p>
                <span className="highlightedText">Commodities </span>– Gold tested its upper zone before fading, while crude saw the biggest weekly loss since June.
              </p>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">The Week Ahead – CPI, Central Banks, and Global Growth Data</p>
              <p>A thin-volume week but loaded with market-moving catalysts. Tuesday’s US CPI and Friday’s global growth figures could set the tone heading into Jackson Hole.</p>

              <p className="highlightedText">Tuesday, August 12</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> CPI (tariff inflation impact)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">China:</span> CPI & PPI
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Australia:</span> RBA Rate Decision (-25bps expected)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">UK:</span> Employment & Earnings Data
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Germany:</span> ZEW Economic Sentiment
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Eurozone:</span> ZEW Economic Sentiment
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Federal Budget Balance
                  </p>
                </li>
              </ul>

              <p className="highlightedText">Wednesday, August 13</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">New Zealand:</span> Electronic Retail Sales (July)
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Japan:</span> PPI (July)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Australia:</span> Wage Price Index (Q2)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Germany:</span> CPI
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Spain:</span> CPI
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Mortgage Applications
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Oil:</span> EIA Weekly Crude Inventory Data
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Auctions:</span> Japan 5Y JGB (0.989% last), Germany 10Y Bund (2.620% last)
                  </p>
                </li>
              </ul>

              <p className="highlightedText">Thursday, August 14</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">UK:</span> GDP & Services Index
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Switzerland:</span> PPI
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">France:</span> CPI
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Eurozone:</span> GDP
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> PPI
                  </p>
                </li>
              </ul>

              <p className="highlightedText">Friday, August 15</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Japan:</span> GDP
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">China:</span> Retail Sales
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">China:</span> Industrial Production
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Retail Sales
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> University of Michigan Consumer Sentiment (Prelim)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Atlanta Fed GDPNow Q3 Estimate
                  </p>
                </li>
              </ul>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image17}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image17)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Alpha Takeaway – Patience Before the Pop</p>
              <p>
                This rally leg is nearer the end than the start. Peace headlines could squeeze markets to fresh highs, but thin breadth and macro divergences suggest chasing here is risky. Gold’s
                consolidation is worth buying on weakness, and bonds could be the stealth winner if deflation pressure builds.
              </p>

              <p className="highlightedBoldText">Our stance: </p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText"> Fade euphoric breakouts</span> into resistance.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Buy gold dips</span> in the buy zone for Q3/Q4 upside.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText"> Size smaller </span> in thin summer trade and prepare for outsized swings on data surprises.
                  </p>
                </li>
              </ul>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image8}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image8)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image2}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image2)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="button_wrapper">
          <button
            className="gradientButton_small "
            onClick={() => {
              handleRedirect("https://docs.google.com/document/d/1VxdIV7emTbzd9DMot1a9Va8nYGL1UNDpVrwjLCAWOS8/edit?tab=t.0");
            }}
          >
            Read In-Depth Market Outlook
          </button>
        </div>
      </div>
      {selectedImage && (
        <BlogImagePopper
          image={selectedImage}
          onClose={() => handleLargeImg(null)}
        />
      )}
    </div>
  );
};

export default Blog31;
